/* search.js: builder A. The search modal on every page (the prototype's site/js/search.js, on Shopify data).
   ML.on('open-search') opens #search-modal (sections/search-modal.liquid): the desktop panel from 1024, the
   full-screen sheet below. At rest it shows popular searches, departments and the two feature brands; while typing
   it shows Shopify predictive search rendered by sections/shop-predictive.liquid (Section Rendering API):
   the brand match, its lines and four products with prices. Enter or "See all results" goes to the search page.
   Queries are sent lowercased (RET-84). Escape, the close button or a click on the dimmed page closes it and
   returns focus to the link that opened it. Arrow keys move through the results. */
(function () {
  'use strict';
  var ML = window.ML;
  var modal = document.getElementById('search-modal');
  if (!ML || !modal) return;
  var mqL = ML.mqL || window.matchMedia('(min-width:1024px)');
  var fields = [document.getElementById('sxd-q'), document.getElementById('sxm-q')];
  if (!fields[0] || !fields[1]) return;
  var live = document.getElementById('sx-live');
  var dEmpty = modal.querySelector('.sxm-d .sx-empty'), dTyping = modal.querySelector('.sxm-d .sx-typing');
  var pEmpty = modal.querySelector('.sxm-p .sx-empty'), pTyping = modal.querySelector('.sxm-p .sx-typing');
  /* (H3) the no-match message ("No products match ...") reads first, with the rest state under it as a way on:
     the results block goes ahead of the rest block (the desktop message carries its 28 px gap for this order) */
  [[dEmpty, dTyping], [pEmpty, pTyping]].forEach(function (b) {
    if (b[0] && b[1] && b[0].parentNode === b[1].parentNode) b[0].parentNode.insertBefore(b[1], b[0]);
  });
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var opener = null, timer = 0, seq = 0, ctrl = null, cache = {};

  function desk() { return mqL.matches; }
  function panel() { return modal.querySelector(desk() ? '.sx-dpanel' : '.sx-pred'); }
  function field() { return fields[desk() ? 0 : 1]; }
  function norm(s) { return String(s || '').trim().toLocaleLowerCase('en'); }
  function setExpanded(on) { fields.forEach(function (f) { f.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
  function clearBtns(q) {
    fields.forEach(function (f) { var c = f.parentNode.querySelector('.sx-clear'); if (c) c.hidden = !q; });
  }
  function rest() {
    dEmpty.hidden = pEmpty.hidden = false;
    dTyping.hidden = pTyping.hidden = true;
    dTyping.innerHTML = pTyping.innerHTML = '';
    setExpanded(false);
    if (live) live.textContent = '';
  }

  function fetchText(url, signal) {
    return fetch(url, { signal: signal, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }
  function load(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var sig = ctrl ? ctrl.signal : undefined;
    var e = encodeURIComponent(q);
    var sugg = root + 'search/suggest?q=' + e + '&resources[type]=product,collection&resources[limit]=10' +
      '&resources[options][unavailable_products]=last&section_id=shop-predictive';
    var count = root + 'search?q=' + e + '&type=product&options[prefix]=last&section_id=shop-predictive';
    return Promise.all([fetchText(sugg, sig), fetchText(count, sig).catch(function () { return ''; })]).then(function (r) {
      var doc = new DOMParser().parseFromString(r[0], 'text/html');
      var tot = new DOMParser().parseFromString(r[1] || '', 'text/html').querySelector('[data-sx-total]');
      var d = doc.querySelector('[data-sx="d"]'), p = doc.querySelector('[data-sx="p"]');
      var n = doc.querySelector('[data-sx-n]');
      var out = {
        d: d ? d.innerHTML : '', p: p ? p.innerHTML : '',
        n: n ? +n.getAttribute('data-sx-n') : 0,
        total: tot ? +tot.getAttribute('data-sx-total') : null
      };
      cache[q] = out;
      return out;
    });
  }
  function render(raw) {
    var q = norm(raw);
    clearBtns(raw);
    if (!q) { seq++; rest(); return; }
    var my = ++seq;
    load(q).then(function (r) {
      if (my !== seq) return;
      dTyping.innerHTML = r.d;
      pTyping.innerHTML = r.p;
      var total = r.total;
      if (total !== null) {
        Array.prototype.forEach.call(modal.querySelectorAll('[data-sx-count]'), function (s) { s.innerHTML = ' &middot; ' + total; });
        Array.prototype.forEach.call(modal.querySelectorAll('[data-sx-count2]'), function (s) { s.textContent = ' ' + total; });
      }
      var none = r.d.indexOf('sx-dgrid') < 0;
      /* no match keeps the rest state below the message, so it is never a dead end */
      dEmpty.hidden = pEmpty.hidden = !none;
      dTyping.hidden = pTyping.hidden = false;
      setExpanded(true);
      if (live) {
        var n = total !== null ? total : r.n;
        live.textContent = none ? 'No products match ' + q : n + (n === 1 ? ' product' : ' products') + ' for ' + q;
      }
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (my !== seq) return;
      /* the request failed: leave the rest state; Enter still goes to the search page */
      rest();
    });
  }

  function open(trigger) {
    if (!modal.hidden) return;
    if (ML.closeMenus) ML.closeMenus();
    opener = trigger || document.activeElement;
    modal.hidden = false;
    ML.lock(true);
    document.querySelectorAll('[data-open="search"]').forEach(function (a) { a.setAttribute('aria-expanded', 'true'); });
    render(field().value);
    field().focus();
  }
  function close() {
    if (modal.hidden) return;
    modal.hidden = true;
    /* (H3) every opening starts fresh: no stale query, results or status from the last visit */
    clearTimeout(timer);
    if (ctrl && ctrl.abort) ctrl.abort();
    fields[0].value = fields[1].value = '';
    clearBtns('');
    seq++;
    rest();
    ML.lock(false);
    document.querySelectorAll('[data-open="search"]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    if (opener && opener.focus) {
      var o = opener;
      if (!o.offsetParent) o = Array.prototype.filter.call(document.querySelectorAll('[data-open="search"]'), function (a) { return a.offsetParent; })[0] || o;
      o.focus();
    }
  }
  document.querySelectorAll('[data-open="search"]').forEach(function (a) {
    a.setAttribute('aria-expanded', 'false');
    a.setAttribute('aria-controls', 'search-modal');
    a.setAttribute('aria-haspopup', 'dialog');
  });
  ML.on('open-search', function (d) { open(d && d.trigger); });

  fields.forEach(function (f, i) {
    f.addEventListener('input', function () {
      fields[1 - i].value = f.value;
      clearTimeout(timer);
      timer = setTimeout(function () { render(f.value); }, 180);
    });
    f.form.addEventListener('submit', function (e) {
      if (!norm(f.value)) { e.preventDefault(); return; }
      f.value = norm(f.value);
    });
    var c = f.parentNode.querySelector('.sx-clear');
    if (c) c.addEventListener('click', function () { fields[0].value = fields[1].value = ''; render(''); f.focus(); });
  });
  modal.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.sx-dscrim') || t.closest('button[aria-label="Close search"]')) { close(); return; }
    var chip = t.closest('a[data-q]');
    if (chip && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      fields[0].value = fields[1].value = chip.getAttribute('data-q');
      render(fields[0].value);
      field().focus();
    }
  });
  modal.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    var p = panel();
    if (!p) return;
    if (e.key === 'Tab') {
      var links = ML.focusables ? ML.focusables(p) : Array.prototype.filter.call(p.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])'), function (el) { return el.offsetParent !== null; });
      if (!links.length) return;
      var first = links[0], last = links[links.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      return;
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var res = Array.prototype.filter.call(p.querySelectorAll('.sx-typing a[href], .sx-empty a[href]'), function (el) { return el.offsetParent !== null; });
      if (!res.length) return;
      var i = res.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (i < 0 ? res[0] : res[Math.min(res.length - 1, i + 1)]).focus();
      else if (i <= 0) field().focus();
      else res[i - 1].focus();
    }
  });
  var onMq = function () { if (!modal.hidden) field().focus(); };
  if (mqL.addEventListener) mqL.addEventListener('change', onMq); else if (mqL.addListener) mqL.addListener(onMq);
})();
